import { apiInstance } from "@core/api/axios/apiInstance";
import { ncfzLoginSchema, ncfzLogoutSchema, loginInfoRawSchema, loginICafeInfoSchema, type NcfzLoginType, type NcfzLogoutType, type LoginInfoRawType, type LoginICafeInfoType } from "@features/auth/model/loginModel";
import { parseSchema } from "@core/model/parseSchema";

export const fetchNcfzLogin = async (data: { secondaryId: string; secondaryPassword: string }) => {
  const res = await apiInstance.post("/account/login", data);
  return parseSchema<NcfzLoginType>({
    schema: ncfzLoginSchema,
    rawData: res?.data,
  });
};

export const fetchNcfzLogout = async () => {
  const res = await apiInstance.post("/account/logout");
  return parseSchema<NcfzLogoutType>({
    schema: ncfzLogoutSchema,
    rawData: res?.data,
  });
};

export const fetchLoginInfo = async () => {
  const res = await apiInstance.get("/account/login-info");
  return parseSchema<LoginInfoRawType>({
    schema: loginInfoRawSchema,
    rawData: res?.data,
  });
};

export const fetchLoginICafeInfo = async (iCafeId: string, signal?: AbortSignal) => {
  const res = await apiInstance.get(`/account/login-icafe-info/${iCafeId}`, { signal });
  return parseSchema<LoginICafeInfoType>({
    schema: loginICafeInfoSchema,
    rawData: res?.data,
  });
};
